import { extendTailwindMerge } from 'tailwind-merge'

export const cn = extendTailwindMerge({
  classGroups: {
    'font-size': [{ text: ['base', 'xs', 'sm', 'md', 'mdlc', 'lg', 'xl', '2xl', '3xl'] }],
  },
})
